// src/components/admin/PopupEditorLibraries.jsx
import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { db } from "../../../firebase";
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";

const DOC_ID = "support_libraries_librarians"; // той самий ID

const quillModules = {
  toolbar: {
    container: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }], // відступи
      [{ align: [] }, { direction: "rtl" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  },
  clipboard: { matchVisual: true },
};

const quillFormats = [
  "header",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "blockquote",
  "code-block",
  "list",
  "indent",
  "align",
  "direction",
  "link",
  "image",
  "video",
];

export default function PopupEditorLibraries() {
  const [value, setValue] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    (async () => {
      try {
        const snap = await getDoc(doc(db, "popups", DOC_ID));
        if (snap.exists()) setValue(snap.data()?.contentHtml || "");
      } catch (e) {
        setError(e?.message || "Помилка завантаження");
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      await setDoc(
        doc(db, "popups", DOC_ID),
        {
          title: "Підтримка бібліотек і бібліотекарів",
          key: "support_libraries_librarians",
          locale: "uk",
          isActive: true,
          contentHtml: value, // HTML з ReactQuill
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );
    } catch (e) {
      setError(e?.message || "Помилка збереження");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: 960, margin: "0 auto", padding: 16 }}>
      <h2 style={{ marginBottom: 8 }}>
        Редактор попапа: «Підтримка бібліотек і бібліотекарів»
      </h2>
      {/* <p style={{ opacity: 0.8, marginBottom: 12 }}>
        Введіть текст українською. Доступні заголовки, списки, відступи,
        вирівнювання, медіа.
      </p> */}

      {!loaded ? (
        <div>Завантаження…</div>
      ) : (
        <>
          <ReactQuill
            theme="snow"
            value={value}
            onChange={setValue}
            modules={quillModules}
            formats={quillFormats}
            placeholder="Опишіть умови, знижки, доставку, контакти…"
          />

          {error && (
            <div style={{ color: "crimson", marginTop: 8 }}>{error}</div>
          )}

          <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
            <button onClick={handleSave} disabled={saving}>
              {saving ? "Зберігаю…" : "Зберегти"}
            </button>
            <button
              type="button"
              onClick={() => setValue("")}
              disabled={saving}
            >
              Очистити
            </button>
          </div>

          {/* <div style={{ marginTop: 24 }}>
            <h3 style={{ marginBottom: 8 }}>Попередній перегляд</h3>
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                padding: 16,
                fontFamily:
                  'Ubuntu, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
                lineHeight: 1.6,
              }}
              dangerouslySetInnerHTML={{ __html: value }}
            />
          </div> */}
        </>
      )}
    </div>
  );
}
